export default __webpack_public_path__ + "static/CircularXXWeb-Bold-50335be87d65a7f398db20437b36d3b9.woff";